import React from 'react';
import { Reveal } from './Reveal';
import { stats } from '../data/curriculum';
export function StatsBar() {
  return <section className="border-y border-brand-dark bg-brand-alt py-8" data-id="element-151" data-mp="1tbjdrfpgvg92">
      <Reveal className="mx-auto grid max-w-5xl grid-cols-2 gap-y-8 px-4 text-center md:grid-cols-4 md:gap-8" data-id="element-152" data-mp="1oavrf7c6nnl6">
        {stats.map(({
        value,
        label
      }, index) => <div key={label} className={`flex flex-col items-center justify-center ${index > 0 ? 'md:border-l md:border-brand-dark' : ''}`} data-id="element-153" data-mp="1jeer7erplirq" data-mpi={index}>
            <span className="mb-1 font-serif text-3xl font-bold text-brand-deep md:text-4xl" data-id="element-154" data-mp="19kxyyf780bq6">{value}</span>
            <span className="text-[10px] font-bold uppercase tracking-wider text-brand-gray md:text-xs" data-id="element-155" data-mp="15l5m3qasnjf0">{label}</span>
          </div>)}
      </Reveal>
    </section>;
}